var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-toolbar-title',{staticClass:"d-flex"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":_vm.statusObject.color}},[_vm._v("fiber_manual_record")]),_vm._v(" "+_vm._s(_vm.statusObject.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }